import React from "react";
import { Link } from "react-router-dom";

import { AppRoutes } from "pages/constants/routes";

import styles from "./EmptyState.module.scss";
import { ReactComponent as Box } from "assets/misc/box.svg";

const EmptyState = () => {
  return (
    <div className={styles.content}>
      <Box className={styles.illustration} />
      <div className={styles.messageBox}>
        <div className={styles.title}>No Projects Found</div>
        <div className={styles.subtitle}>Your projects will be shown here</div>
      </div>
      <Link className={styles.createButton} to={AppRoutes.newProject}>
        Create
      </Link>
    </div>
  );
};

export default EmptyState;
